'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../../i-bem/i-bem.react');

var _bControl = (require('./../../control/control.react.js'), (require('./../../../desktop.blocks/control/control.react.js').default || require('./../../../desktop.blocks/control/control.react.js')).applyDecls());

var _bControl2 = _interopRequireDefault(_bControl);

var _bIconMTypeCrossCrossWebsearchMGlyphXSign = (require('./../../icon/icon.react.js'), require('./../../icon/_glyph/icon_glyph.react.js'), (require('./../../icon/_glyph/icon_glyph_x-sign.react.js').default || require('./../../icon/_glyph/icon_glyph_x-sign.react.js')).applyDecls());

var _bIconMTypeCrossCrossWebsearchMGlyphXSign2 = _interopRequireDefault(_bIconMTypeCrossCrossWebsearchMGlyphXSign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)(_bControl2.default, {
    block: 'textinput',
    elem: 'clear',
    iconType: function iconType() {},
    iconGlyph: function iconGlyph() {},
    attrs: function attrs(_ref) {
        var onClick = _ref.onClick,
            onMouseDown = _ref.onMouseDown;

        return _extends({}, this.__base.apply(this, arguments), {
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    },
    mods: function mods(_ref2) {
        var theme = _ref2.theme,
            visible = _ref2.visible;

        return _extends({}, this.__base.apply(this, arguments), {
            theme: theme,
            visible: this.__self.bool2string(visible)
        });
    },
    render: function render() {
        var block = this.block,
            elem = this.elem,
            _props = this.props,
            disabled = _props.disabled,
            size = _props.size;

        return _react2.default.createElement(_bIconMTypeCrossCrossWebsearchMGlyphXSign2.default, {
            size: size,
            disabled: disabled,
            type: this.iconType(this.props),
            glyph: this.iconGlyph(this.props),
            attrs: this.attrs(this.props),
            mix: [{ block: block, elem: elem, mods: this.mods(this.props) }, { block: block, elem: 'icon' }]
        });
    }
});